import React from "react";
import styled from "styled-components";

export default function TabButton({ onClick, title, active }) {
  return (
    <>
      <TabButtonStyle
        onClick={onClick}
        className={active === title && "active"}
      >
        &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
        <span>{title}</span>
        &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
      </TabButtonStyle>
      &nbsp; &nbsp;
    </>
  );
}

const TabButtonStyle = styled.div`
  width: fit-content;
  border: none;
  color: black;
  border-radius: 5px;
  padding: 12px 17px;
  font-size: 12.6px;
  cursor: pointer;

  &.active {
    background-color: #009bff;
    color: white;
  }

  img {
    margin-right: 10px;
  }
`;
